import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { Box, Button } from '@nerdwallet/currency';
import classes from '@nerdwallet/base-styles/classes';
import _ from 'lodash';

import PressLogoSalad from '../press-logo-salad/press-logo-salad';
import PressArticle from '../press-article/press-article';
import PressLogoTiles from '../../../lib/company-content-src/press-logo-salad-logos';

const PressCategory = ({ articles, displayLogoSalad }) => {
  return (
    <Box className={classNames([classes('margin-bottom-5')])}>
      <Box
        className={classNames([
          'press-category',
          classes('width-100'),
          classes('margin-top-0'),
          classes('margin-bottom-3'),
          classes('margin-horizontal-auto'),
        ])}
        display="flex"
      >
        {_.map(articles, (article, i) => {
          return (
            <article className={classNames('press-article__container')} key={i}>
              <PressArticle key={i} article={article} />
            </article>
          );
        })}
      </Box>
      <Box display="flex" justifyContent="center" marginTop="4">
        <Button href="/news/archive">VIEW ALL STORIES</Button>
      </Box>
      {displayLogoSalad && (
        <PressLogoSalad
          {...PressLogoTiles}
          backgroundColor="#F2EDE6"
          verticalPadding="20px"
        />
      )}
    </Box>
  );
};

PressCategory.propTypes = {
  displayLogoSalad: PropTypes.bool.isRequired,
  articles: PropTypes.array.isRequired,
};

PressCategory.defaultProps = {
  displayLogoSalad: false, // eslint-disable-line react/default-props-match-prop-types
};

PressCategory.displayName = 'PressCategory';

export default PressCategory;
